/** True when HTML has no visible text (empty editor / blank paragraphs). */
export function isStipInstructionsEmpty(html: string): boolean {
  const t = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim();
  return t === "";
}

export function isProbablyRichTextHtml(s: string): boolean {
  const t = s.trim();
  if (!t) return false;
  return /^<[a-z]/i.test(t);
}
